import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.fund.member');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-fund-member',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.widget.fund.member/view.scss */
:host {
  display: block;
  height: 100%;
}

table td,
table th {
  vertical-align: baseline;
}

.form-control {
  border-radius: 4px;
}

.btn-opt {
  margin: 4px;
  border-radius: 30px;
  height: auto;
  font: normal normal normal 16px Montserrat;
  padding: 12px 30px;
  border: 1px solid #72787F;
}
.btn-opt:hover {
  color: #FF5933;
  border: 1px solid #FF5933;
  background-color: #FFF2ED;
}
.btn-opt.active {
  background-color: #FF5933;
  color: #FFF;
  border: 1px solid #FF5933;
}`],
})
export class PortalLpsysadminWidgetFundMemberComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() fund: any;

    public members: any = [];
    public investments: any = [];
    public selected: any = null;
    public summary: any = {};

    public target_user: any = null;
    public show_send_message: any = null;
    public checked_user_id: any = [];

    public sortField: string = 'joined_at';
    public sortOrder: string = 'DESC';

    public userEvent: any = {
        close: async () => {
            this.target_user = null;
            this.show_send_message = null;
            this.checked_user_id = [];
            await this.service.render();
        }
    }

    public roleMap: any = {
        gp: 'GP',
        user: '조합원',
        staff: '담당자'
    }

    public async clickUser(user) {
        this.target_user = null;
        await this.service.render();
        this.target_user = user.id;
        await this.service.render();
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { data } = await wiz.call("list", { id: this.fund.id });
        const invRes = await wiz.call("investments", { id: this.fund.id });
        this.investments = invRes.data || [];

        for (let i = 0; i < data.length; i++) {
            if (!data[i].extra) data[i].extra = {};
            if (!data[i].extra.cert) data[i].extra.cert = [];
            if (!data[i].extra.income_doc) data[i].extra.income_doc = [];
            if (!data[i].extra.deduction) data[i].extra.deduction = {};
            for (let inv of this.investments) {
                if (!data[i].extra.deduction[inv.id]) {
                    data[i].extra.deduction[inv.id] = {};
                }
                if (!data[i].extra.deduction[inv.id].docs) {
                    data[i].extra.deduction[inv.id].docs = [];
                }
            }
            data[i]._originalNo = data.length - i;
        }
        this.members = data;
        let { result, budget } = this.sum();
        this.summary = { result, budget };
        await this.service.render();
    }

    public get sortedMembers() {
        if (!this.members || this.members.length === 0) return [];

        return [...this.members].sort((a, b) => {
            let valA: any, valB: any;

            if (this.sortField === 'joined_at') {
                valA = a.joined_at || '';
                valB = b.joined_at || '';
            } else if (this.sortField === 'name') {
                valA = a.user?.name || '';
                valB = b.user?.name || '';
                const cmp = valA.localeCompare(valB, 'ko');
                return this.sortOrder === 'ASC' ? cmp : -cmp;
            } else if (this.sortField === 'applied_amount') {
                valA = a.applied_amount || 0;
                valB = b.applied_amount || 0;
            }

            if (valA < valB) return this.sortOrder === 'ASC' ? -1 : 1;
            if (valA > valB) return this.sortOrder === 'ASC' ? 1 : -1;
            return 0;
        });
    }

    public async toggleSort(field: string) {
        if (this.sortField === field) {
            this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
        } else {
            this.sortField = field;
            this.sortOrder = field === 'name' ? 'ASC' : 'DESC';
        }
        await this.service.render();
    }

    public sortIcon(field: string): string {
        if (this.sortField !== field) return ' ↕';
        return this.sortOrder === 'ASC' ? ' ▲' : ' ▼';
    }

    public async update() {
        const { code } = await wiz.call("update", { id: this.fund.id, data: JSON.stringify(this.members) });
        if (code == 200)
            await this.service.alert.success("저장되었습니다.");
        else
            await this.service.alert.error("오류가 발생했습니다.");
        await this.service.render();
    }

    public async remove(item) {
        if (item.id) {
            let res = await this.alert(`조합원 '${item.user.name}'을 정말로 삭제하시겠습니까?`, '삭제', '취소');
            if (!res) return;

            const { code } = await wiz.call("remove", { id: this.fund.id, data: JSON.stringify(item) });

            if (code != 200) {
                await this.alert(`오류가 발생했습니다.`);
                return
            }
        }

        await this.load();
    }

    public sum() {
        let members = this.members;
        let result = 0;

        for (let i = 0; i < members.length; i++) {
            let member = members[i];
            if (member.status == '참여')
                result += member.applied_amount;
        }

        let budget = this.service.formatter.currency(result * this.fund.amount_per_share);

        return { result, budget };
    }

    public async alert(message: string, action: string = '확인', cancel: any = false, status: string = 'error') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public mode: string = 'view';

    public async toggle(status) {
        this.mode = status;
        await this.load();
        await this.service.render();
    }

    public isEditable() {
        if (this.fund.investment_status == '결성') return true;
        if (this.mode == 'edit') return true;
        return false;
    }

    public async upload(item, target) {
        let files = await this.service.file.select();
        if (files.length == 0) return;

        await this.service.loading.show();
        for (let i = 0; i < files.length; i++) {
            let fd = new FormData();
            fd.append('upload', files[i]);
            let fdurl = '/file/upload?mode=fund.member-' + item.fund_id + "-" + item.user.id;
            const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
            item.extra[target].push({ name: files[i].name, url: url });
        }
        await this.service.loading.hide();

        await this.update();
        this.service.render();
    }

    public async uploadInvestDoc(item, investId) {
        let inv = this.investments.find(i => i.id === investId);

        // 기본 소득공제 년도 결정 — 기존 year_override → 투자일 → 결성일 → 현재 연도
        let defaultYear = '';
        if (item.extra?.deduction?.[investId]?.year_override) {
            defaultYear = String(item.extra.deduction[investId].year_override);
        } else if (inv?.investment_date) {
            defaultYear = String(inv.investment_date).substring(0, 4);
        } else if (this.fund?.registered_date) {
            defaultYear = String(this.fund.registered_date).substring(0, 4);
        } else {
            defaultYear = String(new Date().getFullYear());
        }

        let yearStr = window.prompt(`소득공제 년도를 입력하세요 (4자리, 예: ${defaultYear})`, defaultYear);
        if (yearStr === null) return;
        yearStr = yearStr.trim();
        if (!/^\d{4}$/.test(yearStr)) {
            await this.service.alert.error("4자리 연도(YYYY)를 입력하세요.");
            return;
        }

        let files = await this.service.file.select();
        if (files.length == 0) return;

        if (!item.extra.deduction) item.extra.deduction = {};
        if (!item.extra.deduction[investId]) item.extra.deduction[investId] = {};
        if (!item.extra.deduction[investId].docs) item.extra.deduction[investId].docs = [];

        // 업로드 시 입력한 년도를 기본 소득공제 년도로 설정 (LP 화면 기본값)
        item.extra.deduction[investId].year_override = yearStr;

        await this.service.loading.show();
        for (let i = 0; i < files.length; i++) {
            let fd = new FormData();
            fd.append('upload', files[i]);
            let fdurl = '/file/upload?mode=fund.member-' + item.fund_id + "-" + item.user.id;
            const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
            item.extra.deduction[investId].docs.push({ name: files[i].name, url: url, year: yearStr });
        }
        await this.service.loading.hide();

        await this.update();
        await this.service.render();
    }

    public deductionLabel(item: any, inv: any, file: any = null): string {
        let year = '';
        if (file?.year) {
            year = String(file.year);
        } else if (item.extra?.deduction?.[inv.id]?.year_override) {
            year = String(item.extra.deduction[inv.id].year_override);
        } else if (inv?.investment_date) {
            year = String(inv.investment_date).substring(0, 4);
        } else if (this.fund?.registered_date) {
            year = String(this.fund.registered_date).substring(0, 4);
        }
        let companyName = inv?.company_name || '-';
        let memberName = item?.user?.name || '-';
        let fundName = this.fund?.name || '-';
        let yearLabel = year ? `${year}년` : '-';
        return `${companyName} · ${yearLabel} · ${memberName} · ${fundName}`;
    }

    public async clearInvestDoc(item, investId, file) {
        item.extra.deduction[investId].docs.remove(file);
        await this.service.render();
        await this.update();
    }

    public async clearValue(obj, key) {
        obj.remove(key)
        await this.service.render();
        await this.update();
    }

    public async onChangeAll(event) {
        const items = Array.from(document.querySelectorAll('input.check-user'));

        items.forEach(i => {
            if (event.target.checked) {
                if (!i.checked) {
                    i.click()
                }
            } else {
                if (i.checked) {
                    i.click()
                }
            }
        });
    }

    public async onChangeUser(user_id, event) {
        if (event.target.checked) {
            this.checked_user_id.push(user_id);
        } else {
            this.checked_user_id = this.checked_user_id.filter((item) => item !== user_id);
        }
    }

    public async onClickSendMessage() {
        this.show_send_message = true;
        await this.service.render();
    }
}

export default PortalLpsysadminWidgetFundMemberComponent;